import { MoreVertical } from 'lucide-react'
import type { DataTableAction } from '@/components/ui/data-table'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { TableCell } from '@/components/ui/table'

interface ActionCellProps<T> {
  item: T
  actions: DataTableAction<T>[]
}

export function ActionCell<T>({ item, actions }: ActionCellProps<T>) {
  if (actions.length === 0) {
    return null
  }

  return (
    <TableCell
      className="!px-6 !py-3 w-12"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-center">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="h-8 w-8 rounded-full hover:bg-muted flex items-center justify-center transition-[color,box-shadow] focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]">
              <MoreVertical className="h-4 w-4 text-foreground" />
              <span className="sr-only">Open menu</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {actions.map((action, actionIndex) => (
              <DropdownMenuItem
                key={actionIndex}
                onClick={() => action.onClick(item)}
                className={
                  action.variant === 'destructive'
                    ? 'text-red-600 focus:text-red-600'
                    : ''
                }
              >
                {action.icon && <span className="mr-2">{action.icon}</span>}
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </TableCell>
  )
}
